'use client';

import type { ReactNode } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import muiTheme from '@/constants/mui-theme';
import styledTheme from '@/constants/styled-theme';

import '@/mui-variables.css';

const combinedTheme = { ...muiTheme, ...styledTheme };

type MuiLegacyStyleProvidersProps = {
  children: ReactNode;
};

export default function MuiLegacyStyleProviders({ children }: MuiLegacyStyleProvidersProps) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={combinedTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
